export default class ExposureV2 {
	constructor() {
		this.minValue = -5;
		this.maxValue = 5;
		this.blockName = "ExposureV2";
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum, {}, false);
		let blockCanvasName = UI.createBlockCanvas(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(".exposure_slider")
			.on("input", _ => this.exposureSliderHandler($(element)));
		$(element)
			.find(".exposure_range")
			.on("change", _ => this.exposureValueHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: this.blockName,
			version: '2',
			passes: [this.addExposurePass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			values: {
				exposure: 0,
			},
		});
	}

	addExposurePass() {
		let shaderPass = gpu.createLiftGammaGainPass();
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	exposureSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let exposureValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, exposureValue);

		let block = lutify.getActiveBlock();
		block.values.exposure = exposureValue;
		block.passes[0].uniforms.exposure.value = exposureValue;
		gpu.render();
	}

	exposureValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let exposureValue = UI.getAdjustmentBlock_rangeValue($el);

		if (exposureValue > this.maxValue) {
			exposureValue = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, exposureValue);
		}
		if (exposureValue < this.minValue) {
			exposureValue = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, exposureValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, exposureValue);
		lutify.getActiveBlock().values.exposure = exposureValue;
		lutify.getActiveBlock().passes[0].uniforms.exposure.value = exposureValue;
		gpu.render();
	}

	applyChanges($block, values) {
		UI.setAdjustmentBlock_rangeValue($block, values.exposure);
		$block.find(".exposure_range").trigger("change");
	}
}
